import { LinkTo } from "@ember/routing";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

<template>
  <div class="border-b border-gray-200 flex" {{mergeClasses}} ...attributes>
    {{#each @tabs as |tab|}}
      <LinkTo
        class="p-3 text-base text-gray-600 hover:text-gray-800 mb-[-1px]"
        data-test-tab="{{tab.route}}"
        @activeClass="text-black! font-semibold border-b border-black"
        @route={{tab.route}}
      >
        {{tab.name}}
      </LinkTo>
    {{/each}}
  </div>
</template>
